import { Toolbar } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { HeaderSettings } from '../../constants/HeaderMenu';
import AuthContext from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIProvider';

import './Header.css';
import UpdatedAcceptPolicies from './UpdatedAcceptPolicies';
import usePatientsForDoctor from '../../hooks/usePatientsForDoctor';
import { useNotificationContext } from '../../contexts/NotificationContext';
import { ACM } from '../../constants/UserRoles';
import HeaderActions from './components/HeaderActions';
import RemindersDialog from './components/RemindersDialog';
import HeaderTitle from './components/HeaderTitle';
import AnalyticsService from './components/AnalyticsService';
import useUserMenuHandlers from './components/UserMenuHandlers';
import useNotificationHandlers from './components/NotificationHandlers';

const Header = ({ onclick }) => {
  // const { ACM } = useContext(ACMContext);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [notificationAnimation, setNotificationAnimation] = useState(false);
  const [openReminders, setOpenReminders] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState([]);
  const [title, setTitle] = useState('');
  const navigate = useNavigate();

  const {
    user,
    typeOfUser,
    logout,
    setOpenRightPanel,
    setPanelContent,
    setIsNotificationPanel,
    setIsTreatmentsPanel,
    setPanelTitle,
  } = useContext(AuthContext);
  const {
    updateSelectedMenu,
    setSelectedMenuKey,
    selectedMenuKey,
    isDrawerOpen,
    setIsDrawerOpen,
    isSmallScreen,
  } = useContext(UIContext);

  const {
    data: patientData = [],
    // eslint-disable-next-line no-unused-vars
    isLoading,
    // eslint-disable-next-line no-unused-vars
    error: errorPatientData,
  } = usePatientsForDoctor(user?.uid);

  // Use the NotificationContext for global notification management
  const notificationContext = useNotificationContext();
  const {
    notifications = [],
    unreadCount = 0,
    // eslint-disable-next-line no-unused-vars
    refetchNotifications,
    fetchNotifications,
    isLoading: notificationsLoading,
  } = notificationContext;

  const [patientsLoaded, setPatientsLoaded] = useState(false);
  const [isUserExists, setIsUserExists] = useState(false);

  const location = useLocation();

  // Analytics service component handles all analytics functions
  <AnalyticsService />;

  // User menu handlers hook
  const { handleOpenUserMenu, handleCloseUserMenu, settingClickHandler } =
    useUserMenuHandlers({
      setAnchorElUser,
      ACM,
      typeOfUser,
      user,
      logout,
      setSelectedMenuKey,
      updateSelectedMenu,
      navigate,
    });

  const handleOpenReminders = () => {
    setOpenReminders(true);
  };

  const handleCloseReminders = () => {
    setOpenReminders(false);
  };

  const formatName = (name) => {
    return name
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const pickFirstValidString = (values = []) => {
    const validValue = values.find(
      (value) => typeof value === 'string' && value.trim().length > 0
    );
    return validValue ? validValue.trim() : '';
  };

  const resolveGoalHeaderInfo = () => {
    const goalState = location.state?.goals;
    const goalDataState = location.state?.goalData;

    const studentName = pickFirstValidString([
      location.state?.studentName,
      location.state?.student?.fullname,
      location.state?.student?.name,
      location.state?.student?.info?.StudentName,
      goalState?.studentName,
      goalState?.info?.StudentName,
      goalState?.info?.Student?.fullname,
      goalState?.info?.Student?.name,
      goalDataState?.info?.StudentName,
      goalDataState?.info?.GoalDetails?.StudentName,
      goalDataState?.info?.GoalDetails?.studentName,
      goalDataState?.GoalDetails?.StudentName,
      goalDataState?.GoalDetails?.studentName,
      goalDataState?.studentName,
      goalDataState?.StudentName,
      goalDataState?.Student?.fullname,
      goalDataState?.Student?.name,
      goalDataState?.dataCollection?.StudentName,
      goalDataState?.dataCollection?.GoalDetails?.StudentName,
      goalDataState?.info?.Student?.fullname,
      goalDataState?.info?.Student?.name,
      goalDataState?.info?.GoalDetails?.Student?.fullname,
      goalDataState?.info?.GoalDetails?.Student?.name,
    ]);

    const goalTitle = pickFirstValidString([
      location.state?.goalTitle,
      goalState?.GoalTitle,
      goalState?.info?.GoalDetails?.GoalTitle,
      goalDataState?.GoalDetails?.GoalTitle,
      goalDataState?.GoalDetails?.GoalName,
      goalDataState?.GoalDetails?.goalTitle,
      goalDataState?.info?.GoalDetails?.GoalTitle,
      goalDataState?.GoalTitle,
      goalDataState?.goalTitle,
    ]);

    return { studentName, goalTitle };
  };

  React.useEffect(() => {
    let key = localStorage.getItem('selectedMenuKey') || selectedMenuKey;

    if (location.pathname === '/') {
      const formattedUserName = user?.fullname || user?.displayName || 'User';
      const formattedTitle = formatName(formattedUserName);
      setTitle(`Welcome, ${formattedTitle}`);
    } else if (
      location.pathname === '/goalDetails' &&
      (location.state?.goals || location.state?.goalData)
    ) {
      const { studentName, goalTitle } = resolveGoalHeaderInfo();

      if (studentName && goalTitle) {
        setTitle(`${studentName} - ${goalTitle}`);
      } else if (studentName || goalTitle) {
        setTitle(studentName || goalTitle);
      } else {
        setTitle('View Goal');
      }
    } else if (
      location.pathname === '/viewallpatientvideos' ||
      location.pathname === '/viewallvideos'
    ) {
      setTitle(`Videos`);
    } else if (location.pathname === '/progress-report') {
      setTitle('Progress Report');
    } else if (location.pathname === '/trend-analysis') {
      setTitle('Trend Analysis Report');
    } else if (
      localStorage.getItem('selectedPatientId') !== '-1' &&
      selectedMenuKey !== 'Home'
    ) {
      const reportTitle = ACM[typeOfUser]?.isDoctor
        ? 'Patient Report'
        : 'Student Report';
      setTitle(reportTitle);
    } else if (key === 'Appointments') {
      setTitle('Appointments');
    } else if (key === 'Statistics') {
      setTitle('Statistics');
    } else if (key === 'HistoricalData') {
      setTitle('Historical Data');
    } else if (key === 'Settings') {
      setTitle(`Settings`);
    } else if (key === 'Goals') {
      if (location.pathname === '/quicktrackDashboard') {
        setTitle('QuickTrack Dashboard');
      } else if (location.pathname === '/allgoals') {
        setTitle('Goals Overview');
      } else if (location.pathname === '/pendinggoals') {
        (ACM[typeOfUser]?.isStudent || ACM[typeOfUser]?.isPatient) ? setTitle('Pending Goals') : setTitle('Pending Goals & QuickTracks');
      } else if (location.pathname === '/quickTrackView') {
        const studentName = location.state?.behavior?.info?.StudentName;
        const quickTrackName =
          location.state?.behavior?.info?.BehaviorDetails?.Type?.BehaviorName ||
          location.state?.behavior?.info?.BehaviorDetails?.Type?.SkillName;

        if (studentName && quickTrackName) {
          setTitle(`${studentName} - ${quickTrackName}`);
        } else {
          setTitle('QuickTrack View');
        }
      } else {
        setTitle('Goals Dashboard');
      }
    } else if (key === 'Privacy') {
      setTitle('Privacy Statement');
    } else if (key === 'Videos') {
      setTitle('Videos');
    } else if (key === 'Termcondition') {
      setTitle('Term and Conditions');
    } else if (key === 'Contact') {
      setTitle('Contact Information');
    } else if (key === 'Userguide') {
      setTitle('User Guide');
    } else if (key === 'Messaging') {
      setTitle('Messaging');
    } else if (key === 'Schools') {
      setTitle('School Management');
    } else if (key === 'Organization Admin') {
      setTitle('Organization Management');
    } else if (key === 'School Admin') {
      setTitle('School Admin Management');
    } else if (key === 'Permissions') {
      setTitle('Permissions');
    } else if (key === 'Teachers') {
      setTitle('Teacher Management');
    } else if (key === 'Students') {
      setTitle('Student Management');
    } else if (key === 'Terms and Policies') {
      setTitle('Terms and Policies');
    } else if (key === 'School Admin') {
      setTitle('School Admin Information');
    } else if (key === 'Teacher List') {
      setTitle('Teacher Management');
    } else if (key === 'Student List') {
      setTitle('Student Management');
    } else if (key === 'Admin Schools') {
      setTitle('Schools List');
    } else if (key === 'School List') {
      setTitle('Schools List');
    } else if (key === 'School Admins') {
      setTitle('Admins List');
    } else {
      // For pages that don't have specific menu keys, show empty title
      // Only show welcome message if we're actually on the home page
      if (location.pathname === '/') {
        const formattedUserName = user?.fullname || user?.displayName || 'User';
        const formattedTitle = formatName(formattedUserName);
        setTitle(`Welcome, ${formattedTitle}`);
      } else {
        setTitle('');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMenuKey, user, location]);

  useEffect(() => {
    if (user) {
      setIsUserExists(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    patientData?.length > 0 && setPatientsLoaded(true);
  }, [patientData]);

  useEffect(() => {
    if (location.pathname === '/') {
      updateSelectedMenu('Home');
      // The title will be set by the main useEffect, so we don't need to set it here
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, user]);

  // Notification handlers hook
  const { handleShowNotifications, renderUnreadMessageCounts } =
    useNotificationHandlers({
      setPanelContent,
      setOpenRightPanel,
      setIsNotificationPanel,
      setIsTreatmentsPanel,
      setPanelTitle,
      setnotificationCount: unreadCount,
      notifications: notifications,
      fetchNotifications,
      ACM,
      typeOfUser,
      unreadCounts,
      setUnreadCounts,
      user,
      patientData,
      patientsLoaded,
      isUserExists,
    });

  // Notification animation effect - trigger on new notifications
  const [previousUnreadCount, setPreviousUnreadCount] = useState(0);

  useEffect(() => {
    // Trigger animation when unread count increases
    if (unreadCount > previousUnreadCount && unreadCount > 0) {
      setNotificationAnimation(true);
      setTimeout(() => setNotificationAnimation(false), 1000);
    }

    setPreviousUnreadCount(unreadCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadCount]);

  return (
    <>
      {/* {typeOfUser !== "ADMIN" && <UpdatedAcceptPolicies />} */}
      {ACM[typeOfUser]?.canAcceptPolicies && <UpdatedAcceptPolicies />}
      <Toolbar disableGutters className='header'>
        <HeaderTitle
          isSmallScreen={isSmallScreen}
          setIsDrawerOpen={setIsDrawerOpen}
          isDrawerOpen={isDrawerOpen}
          title={title}
          ACM={ACM}
          typeOfUser={typeOfUser}
          location={location}
          user={user}
        />

        <HeaderActions
          ACM={ACM}
          typeOfUser={typeOfUser}
          user={user}
          notificationCount={notificationsLoading ? '⟳' : unreadCount}
          notificationAnimation={notificationAnimation || notificationsLoading}
          anchorElUser={anchorElUser}
          handleOpenReminders={handleOpenReminders}
          handleShowNotifications={handleShowNotifications}
          handleOpenUserMenu={handleOpenUserMenu}
          handleCloseUserMenu={handleCloseUserMenu}
          settingClickHandler={settingClickHandler}
          updateSelectedMenu={updateSelectedMenu}
          HeaderSettings={HeaderSettings}
        />
      </Toolbar>
      {renderUnreadMessageCounts()}
      <RemindersDialog
        openReminders={openReminders}
        handleCloseReminders={handleCloseReminders}
      />
    </>
  );
};

export default Header;
